import { createSlice } from "@reduxjs/toolkit";
import APIService from "../services/api.service";
import { AppDispatch } from "../store";

const initialState = {
  unknownDialogOpen: false,
  unknownId: null,
  description: null,
  comment: null,
  outcome: null,
  no_go: 0,
  move: null,
  positive_impact: 1,
  negative_impact: 1,
  concernings: [],
  selectedMoves: [],
  selectedConcernings: [],
  currentSection: 'details', // tracks which section of the form is active
  isEditabled: true,
  isDuplicated: false,
  unknownIsLoading: false,
  unknownStatus: null,
  unknownNextAction: null,
  unknowns: [],
};

export const unknownSlice = createSlice({
  name: "unknown",
  initialState,
  reducers: {
    openUnknownDialog: (state, action) => {
      // initialize
      state.unknownId = null;
      state.description = null;
      state.comment = null;
      state.outcome = null;
      state.no_go = 0;
      state.positive_impact = 1;
      state.negative_impact = 1;
      state.concernings = [];
      state.move = null;
      state.selectedMoves = [];
      state.selectedConcernings = [];
      state.currentSection = 'details';

      state.unknownDialogOpen = true;
      // if (action.payload!== undefined && action.payload!== null && Object.is(action.payload, {})) {
      if (action.payload.element.id) {
        // Element
        if (action.payload.isDuplicated === true) {
          state.unknownId = null;
          state.description = `${action.payload.element.description} - copy`;
        } else {
          state.unknownId = action.payload.element.id;
          state.description = action.payload.element.description;
        }
        state.comment = action.payload.element.comment;
        state.outcome = action.payload.element.outcome;
        state.no_go = action.payload.element.no_go;
        state.positive_impact = action.payload.element.positive_impact;
        state.negative_impact = action.payload.element.negative_impact;
        state.concernings = action.payload.element.concernings;
        state.move = action.payload.element.move;
        state.selectedMoves = action.payload.element.selectedMoves || [];
        // Convert concernings objects to strings for selectedConcernings
        const concerningsArray = action.payload.element.concernings || [];
        state.selectedConcernings = concerningsArray.map(concerning => {
          if (typeof concerning === 'object' && concerning !== null) {
            return concerning.value || concerning.id || concerning;
          }
          return concerning;
        });
        // Other
        state.isEditabled = action.payload.isEditabled;
        state.isDuplicated = action.payload.isDuplicated;
      }
    },
    closeUnknownDialog: (state) => {
      state.unknownDialogOpen = false;
    },
    loadingUnknown: (state) => {
      state.unknownIsLoading = true;
      state.unknownStatus = null;
    },
    failUnknown: (state, action) => {
      state.unknownIsLoading = false;
      state.unknownStatus = action.payload;
    },
    resetUnknown: (state, action) => {
      state.description = '';
      state.comment = '';
      state.outcome = '';
      state.no_go = 0;
      state.positive_impact = 1;
      state.negative_impact = 1;
      state.concernings = [];
      state.selectedMoves = [];
      state.selectedConcernings = [];
      state.currentSection = 'details';
      state.unknownIsLoading = false;
      state.unknownStatus = 'success';
      state.unknownNextAction = action.payload;
    },
    resetUnknownStatus: (state) => {
      state.unknownStatus = null;
    },
    putUnknowns: (state, action) => {
      console.log('unknown slice', action.payload)
      state.unknowns = [];
      if (action.payload !== null) {
        Object.assign(state.unknowns, action.payload)
      }
    },
    setCurrentSection: (state, action) => {
      state.currentSection = action.payload;
    },
    addSelectedMove: (state, action) => {
      const moveId = action.payload.id;
      const existingMove = state.selectedMoves.find(move => move.id === moveId);
      if (!existingMove) {
        state.selectedMoves.push(action.payload);
      }
    },
    removeSelectedMove: (state, action) => {
      const moveId = action.payload;
      state.selectedMoves = state.selectedMoves.filter(move => move.id !== moveId);
    },
    clearSelectedMoves: (state) => {
      state.selectedMoves = [];
    },
    addSelectedConcerning: (state, action) => {
      const concerningId = action.payload;
      if (!state.selectedConcernings.includes(concerningId)) {
        state.selectedConcernings.push(concerningId);
      }
    },
    removeSelectedConcerning: (state, action) => {
      const concerningId = action.payload;
      state.selectedConcernings = state.selectedConcernings.filter(id => id !== concerningId);
    },
    clearSelectedConcernings: (state) => {
      state.selectedConcernings = [];
    }
  },
});

export const {
  openUnknownDialog,
  closeUnknownDialog,
  loadingUnknown,
  failUnknown,
  resetUnknown,
  resetUnknownStatus,
  putUnknowns,
  setCurrentSection,
  addSelectedMove,
  removeSelectedMove,
  clearSelectedMoves,
  addSelectedConcerning,
  removeSelectedConcerning,
  clearSelectedConcernings
} = unknownSlice.actions;

export default unknownSlice.reducer;

export const unknownPost = (nextAction, data: any, id: any = null) => async (dispatch: AppDispatch) => {
  try {
    dispatch(loadingUnknown());
    if (id !== null && id !== undefined) {
      await APIService.put(`/unknowns/${id}`, data).then((response) => {
        dispatch(resetUnknown(nextAction));
      });
    } else {
      await APIService.post("/unknowns", data).then((response) => {
        dispatch(resetUnknown(nextAction));
      });
    }
  } catch (e) {
    console.log(e);
    dispatch(failUnknown(e?.response?.data?.message || 'error on request'));
  }
};

export const unknownGetAll = () => async (dispatch: AppDispatch) => {
  try {
    await APIService.get("/unknowns").then((response) => {
      dispatch(putUnknowns(response.data.items));
    });

  } catch (e) {
    console.log(e);
    // dispatch(setCustomerError());
  }
};

export const unknownDelete = (id: string) => async (dispatch: AppDispatch) => {
  try {
    await APIService.delete(`/unknowns/${id}`).then((response) => {
      console.log(response);
    });
  } catch (e) {
    console.log(e);
  }
};